import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@mes-slalom/ui-common-lib';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

const AWS_PRESIGNED_PARAM_MARKERS = [
  'X-Amz-Algorithm=',
  'X-Amz-Credential=',
  'X-Amz-Date=',
  'X-Amz-Expires=',
  'X-Amz-Signature=',
];

const isAwsPresignedUrl = (url: string): boolean =>
  AWS_PRESIGNED_PARAM_MARKERS.some((marker) => url.includes(marker));

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // Explicit opt-out for requests that must not include bearer auth (e.g. PUT to S3 presigned URLs).
  if (req.context.get(SKIP_AUTH) || isAwsPresignedUrl(req.url)) {
    return next(req);
  }

  // OAuth flow calls go directly to Cognito and must not have our bearer token attached.
  if (req.url.includes(environment.authEndpoint)) {
    return next(req);
  }

  return from(auth.getValidAccessToken()).pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      return next(req);
    })
  );
};
